export enum SortingType {
  PriceChange = 'PRICE_CHANGE',
  MarketCap = 'MARKET_CAP',
  Price = 'PRICE',
  CoinName = 'COIN_NAME',
}
